'use client';
import React from 'react';
var NavContext = /*#__PURE__*/React.createContext(null);
export default NavContext;